// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2nGfB","selected":"Chip_selected__3kT01"};